import { createReducer } from '@common/utils/redux';
import { NEW_PEDIGREE_ACTION_TYPES } from '../const/pedigree';

const initialState = {
  folders: [],
  questionnaires: [],
  pedigreeNameError: null,
};

export default createReducer(
  initialState,
  {
    [NEW_PEDIGREE_ACTION_TYPES.getFolders]: (state, folders) => ({
      ...state,
      folders
    }),
    [NEW_PEDIGREE_ACTION_TYPES.getQuestionnaires]: (state, questionnaires) => ({
      ...state,
      questionnaires,
    }),
  }
);